import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/components/home/home'
import ContactUs from '@/components/contact-us'
import AboutUs from '@/components/about-us'
import ProductsIndex from '@/components/products/index'
import ViewProduct from '@/components/products/view-product'
import TechnicalSupport from '@/components/technical support/index'
import NewsAndEvents from '@/components/news and events/index'
import ViewNews from '@/components/news and events/view-news'
import CommingSoon from '@/components/comming soon/comming-soon'
import JoinUs from '@/components/join-us'

Vue.use(Router);

export default new Router({
    linkExactActiveClass: 'active',
    mode: 'history',
    routes: [{
            path: '/',
            name: 'home',
            component: Home
        },
        {
            path: '/contact-us',
            name: 'contact-us',
            component: ContactUs
        },
        {
            path: '/about-us',
            name: 'about-us',
            component: AboutUs
        },
        {
            path: '/products/:section?',
            name: 'products',
            component: ProductsIndex
        },
        {
            path: '/products/view/:id/:name?',
            name: 'view-product',
            component: ViewProduct
        },
        {
            path: '*',
            name: 'home-redirect',
            component: Home
        },
        {
            path: '/technical-support',
            name: "technical-support",
            component: TechnicalSupport
        },
        {
            path: '/news-events',
            name: "news-and-events",
            component: NewsAndEvents
        },
        {
            path: '/news-events/:id',
            name: "view-news",
            component: ViewNews
        }, {
            path: '/comming-soon',
            name: 'comming-soon',
            component: CommingSoon
        },
        {
            path: '/join-us',
            name: 'join-us',
            component: JoinUs
        }

    ]
});


// WEBPACK FOOTER //
// ./src/router/index.js